import PropTypes from 'prop-types'
import classNames from 'classnames'
import parse from 'html-react-parser'

import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'
import { sanitizeNoteNode, REPORT_TEXT_ALLOWED_TAGS } from '@aytm/app/stats/lib/render/note-html'

import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

import style from '@aytm/app/stats/page/question-views/info-view/components/styles/Text.module.scss'

// Info-view text block: HTML text arranged in columns, with an optional 85px thumbnail.
// Replaces info_view/text.coffee (#info-view-question-block-text-template + initColumns).

// 85px-capped thumbnail width, mirroring the template's aspect-ratio math.
const thumbWidth = image => {
  const s = 85
  let w = image.original.width
  const h = image.original.height
  if (s < w || s < h) {
    const r = w / h
    w = r < 1 ? s * r : s
  }
  return w
}

const columnStyle = (cols, hasImage) => ({
  width: hasImage ? `calc(${100 / cols}% - 105px)` : `${100 / cols}%`
})

// The ingest stores a report body verbatim, so the allow-list is applied here at render.
const renderText = text => {
  const parserOptions = {
    replace: domNode => sanitizeNoteNode(domNode, parserOptions, REPORT_TEXT_ALLOWED_TAGS)
  }
  return parse(String(text), parserOptions)
}

const Text = ({ texts, image, format, hasImage }) => {
  const list = (Array.isArray(texts) ? texts : [texts]).filter(t => t != null)
  const cols = parseInt(format.cols || list.length, 10) || 1
  const colStyle = columnStyle(cols, hasImage)

  let columns
  if ('columns' === format.layout) {
    const rows = Math.ceil(list.length / cols)
    const byColumn = 'col' === format.direction
    columns = Array.from({ length: cols }, (_, i) => (
      <div key={i} className={style.column} style={colStyle}>
        {Array.from({ length: rows }, (_, j) => {
          const text = list[byColumn ? j + i * rows : i + j * cols]
          return text ? <div key={j}>{renderText(text)}</div> : null
        })}
      </div>
    ))
  } else {
    columns = list
      .filter(Boolean)
      .map((text, i) => (
        <div key={i} className={style.column} style={colStyle}>
          {renderText(text)}
        </div>
      ))
  }

  return (
    <BlockWrapper>
      <div className={classNames(style.component, format.style && style[format.style])}>
        {image && image.original ? (
          <div className={style.image}>
            <div className={style.thumbnail} style={{ width: `${thumbWidth(image)}px`, height: 'auto' }}>
              <img
                alt=""
                src={getImageAssetPath({
                  path: image.original.path,
                  width: 85,
                  height: 85,
                  filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
                  backgroundColor: 'white'
                })}
              />
            </div>
          </div>
        ) : null}
        {columns}
      </div>
    </BlockWrapper>
  )
}

Text.displayName = 'Text'

Text.propTypes = {
  texts: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  image: PropTypes.object,
  format: PropTypes.object,
  hasImage: PropTypes.bool
}

Text.defaultProps = {
  format: {}
}

export default Text
